import { makeStyles } from 'tss-react/mui';

const useStylesPageTitleSeparator: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  pageTitleSeparator: {
    height: 24,
    paddingRight: 15,
    marginLeft: 15,
    borderLeft: `2px solid ${theme.palette.info.main}`,
  },
}));

export default useStylesPageTitleSeparator;
